import React, { useState } from "react";
import PageContainer from "../../components/PageContainer";
import { useParams } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useGalleryPhotographs } from "../../hooks/useGalleries";
import { Masonry } from "@mui/lab";

export default function SingleGallery() {
    const { galleryId } = useParams<{ galleryId: string }>();
    const [index, setIndex] = useState<number>(-1);

    const { data: photographsData, isLoading, isError } = useGalleryPhotographs(galleryId || "");

    if (isLoading) {
        return (
            <PageContainer title="Gallery">
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                    <CircularProgress color="inherit" />
                </Box>
            </PageContainer>
        );
    }

    if (isError || !galleryId) {
        return (
            <PageContainer title="Error">
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                    <Typography>Galeri yüklenirken bir hata oluştu.</Typography>
                </Box>
            </PageContainer>
        );
    }

    return (
        <PageContainer title="Gallery">
            <Lightbox
                open={index >= 0}
                close={() => setIndex(-1)}
                slides={photographsData || []}
                index={index}
                plugins={[Captions, Fullscreen, Thumbnails, Zoom, Counter]}
                styles={{
                    root: {
                        "--yarl__color_backdrop": "#fff",
                        "--yarl__color_button": "#444",
                        "--yarl__color_button_active": "#000",
                    },
                }}
            />
            <Masonry 
                sx={{ overflowX: "hidden", m: 0, p: 2 }} 
                columns={{ xs: 1, sm: 2, md: 3 }} 
                spacing={2}
            >
                {(photographsData || []).map((item, idx) => (
                    <Box 
                        key={item.id}
                        onClick={() => setIndex(idx)}
                        sx={{
                            cursor: 'pointer',
                            transition: "transform 0.2s ease",
                            '&:hover': { transform: 'scale(1.02)' }
                        }}
                    >
                        <img
                            src={item.src}
                            alt='eseruyanik'
                            style={{ width: '100%', display: 'block' }}
                        />
                    </Box>
                ))}
            </Masonry>
        </PageContainer>
    );
}
